(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.core.js'), require('kendo.ooxml.cmn.chunk.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'kendo.core', 'kendo.ooxml.cmn.chunk'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.Ooxml = {}), global.kendo._globals.Core, global.kendo._globals.OoxmlCmnChunk));
})(this, (function (exports, kendo_core_js, kendo_ooxml_cmn_chunk_js) {
    const __meta__ = {
        id: "ooxml",
        name: "XLSX generation",
        category: "framework",
        advanced: true,
        mixin: true,
        depends: ["core", "ooxml.cmn.chunk"]
    };

    (function($) {

        kendo_ooxml_cmn_chunk_js.I.register({
            toString: kendo.toString
        });


        let convertedWorkbook = kendo.ConvertClass(kendo_ooxml_cmn_chunk_js.W);
        var toDataURL = convertedWorkbook.prototype.toDataURL;

        Object.assign(convertedWorkbook.prototype, {
            toDataURL: function() {
                var result = toDataURL.call(this);
                if (typeof result !== 'string') {
                    throw new Error('The toDataURL method can be used only with jsZip 2. Either include jsZip 2 or use the toDataURLAsync method.');
                }

                return result;
            },

            toDataURLAsync: function() {
                var deferred = $.Deferred();
                var result = toDataURL.call(this);
                if (typeof result === 'string') {
                    result = deferred.resolve(result);
                } else if (result && result.then) {
                    result.then(function(dataURI) {
                        deferred.resolve(dataURI);
                    }, function() {
                        deferred.reject();
                    });
                }

                return deferred.promise();
            }
        });

        window.kendo.ooxml = window.kendo.ooxml || {};
        window.kendo.ooxml.IntlService = kendo_ooxml_cmn_chunk_js.I;
        window.kendo.ooxml.Workbook = convertedWorkbook;
        window.kendo.ooxml.Worksheet = kendo.ConvertClass(kendo_ooxml_cmn_chunk_js.a);
        window.kendo.ooxml.createZip = function() {
            /* global JSZip */
            if (typeof JSZip === "undefined") {
                throw new Error("JSZip not found. Check http://docs.telerik.com/kendo-ui/framework/excel/introduction#requirements for more details.");
            }

            return new JSZip();
        };

    })(window.kendo.jQuery);

    exports.__meta__ = __meta__;

}));
